import { assertEnvHasProps } from './assertEnvHasProps';
export var checkEnv = function (props, assert) {
    if (assert === void 0) { assert = false; }
    var missing = props.filter(function (prop) { return !process.env[prop]; });
    if (assert)
        assertEnvHasProps(process.env, props);
    return missing.length === 0;
};
